import { apiClient } from "@/lib/apiClient";

/** Profile service — the only place the UI talks to profile endpoints. */
export const profileService = {
  async getBusiness() {
    const { data } = await apiClient.get("/profile/business");
    return data.profile;
  },
  async saveBusiness(payload) {
    const { data } = await apiClient.put("/profile/business", payload);
    return data.profile;
  },
  async getBrand() {
    const { data } = await apiClient.get("/profile/brand");
    return data.profile;
  },
  async saveBrand(payload) {
    const { data } = await apiClient.put("/profile/brand", payload);
    return data.profile;
  },
  async getCompleteness() {
    const { data } = await apiClient.get("/profile/completeness");
    return data;
  },
};
